import { P2PProvider } from 'types';

import { createCrudApi } from './crud.api';

export const p2pProvidersApi = createCrudApi<P2PProvider>('/p2p-providers');
